export const translations = {
  pt: {
    nav: {
      home: 'Início',
      services: 'Serviços',
      about: 'Sobre',
      contact: 'Pedir Orçamento',
      booking: 'Agendar',
      gallery: 'Galeria'
    },
    hero: {
      title: 'Serviços Residenciais e Comerciais de Confiança',
      subtitle: 'Pintura, reparos, limpeza e manutenção profissional no Algarve-Faro. Atendimento direto, preços justos e qualidade garantida.',
      cta: 'Pedir Orçamento'
    },
    services: {
      title: 'Os Nossos Serviços',
      subtitle: 'Soluções completas para sua casa ou negócio',
      painting: {
        title: 'Pintura',
        description: 'Pintura de quartos e pequenos espaços com acabamento profissional'
      },
      repairs: {
        title: 'Pequenos Reparos',
        description: 'Troca de lâmpadas, tomadas, fechaduras e ajustes diversos'
      },
      cleaning: {
        title: 'Limpeza',
        description: 'Limpeza profissional residencial para sua comodidade'
      },
      maintenance: {
        title: 'Manutenção',
        description: 'Manutenção básica de imóveis com profissionalismo'
      },
      furniture: {
        title: 'Montagem de Móveis',
        description: 'Montagem rápida e segura de móveis diversos'
      }
    },
    whyChoose: {
      title: 'Por Que Escolher a Sancur?',
      punctuality: {
        title: 'Pontualidade',
        description: 'Respeitamos seu tempo e cumprimos prazos acordados'
      },
      professionalism: {
        title: 'Profissionalismo',
        description: 'Equipa qualificada e atendimento de excelência'
      },
      fairPrice: {
        title: 'Preço Justo',
        description: 'Sem intermediários, você paga menos com qualidade garantida'
      },
      speed: {
        title: 'Rapidez',
        description: 'Serviços ágeis sem comprometer a qualidade'
      }
    },
    howItWorks: {
      title: 'Como Funciona',
      step1: {
        title: 'Contacte-nos',
        description: 'Entre em contacto por telefone, WhatsApp ou formulário'
      },
      step2: {
        title: 'Orçamento',
        description: 'Receba um orçamento claro e transparente'
      },
      step3: {
        title: 'Serviço',
        description: 'Executamos o trabalho com qualidade e pontualidade'
      }
    },
    testimonials: {
      title: 'O Que Dizem os Nossos Clientes',
      review1: {
        text: 'Serviço excelente! Pintaram meu quarto em um dia e o resultado ficou perfeito. Muito profissionais.',
        author: 'Maria Silva',
        location: 'Faro'
      },
      review2: {
        text: 'Precisava de vários pequenos reparos em casa. Fizeram tudo rapidamente e com ótimo preço.',
        author: 'João Santos',
        location: 'Albufeira'
      },
      review3: {
        text: 'Montaram meus móveis novos com muita eficiência. Recomendo sem dúvida!',
        author: 'Ana Costa',
        location: 'Lagos'
      }
    },
    beforeAfter: {
      title: 'Antes e Depois',
      subtitle: 'Veja a qualidade do nosso trabalho'
    },
    guarantee: {
      title: 'Garantia de Satisfação',
      description: 'Trabalhamos até você ficar completamente satisfeito com o resultado'
    },
    about: {
      title: 'Sobre a Sancur Property Services',
      story: 'Fundada em 2022 com o objetivo de trazer mais conforto para a casa das pessoas, a Sancur Property Services nasceu de uma visão simples: oferecer serviços de qualidade sem intermediários. Queremos que você pague menos enquanto recebe um atendimento personalizado e profissional.',
      mission: {
        title: 'Nossa Missão',
        description: 'Proporcionar serviços residenciais e comerciais de excelência, com atendimento direto e preços justos, garantindo a satisfação total dos nossos clientes.'
      },
      values: {
        title: 'Nossos Valores',
        list: [
          'Transparência em todos os orçamentos',
          'Compromisso com qualidade e prazos',
          'Atendimento personalizado e humano',
          'Honestidade e confiança em cada serviço'
        ]
      },
      commitment: {
        title: 'Nosso Compromisso',
        description: 'Na Sancur, você lida diretamente com quem executa o serviço. Sem intermediários, sem surpresas. Apenas trabalho bem feito, com respeito pelo seu tempo e seu espaço.'
      }
    },
    servicesPage: {
      title: 'Nossos Serviços',
      subtitle: 'Soluções completas para sua casa e negócio no Algarve',
      cta: 'Solicitar Orçamento'
    },
    contact: {
      title: 'Pedir Orçamento',
      subtitle: 'Ainda não tem certeza? Peça um orçamento sem compromisso',
      form: {
        title: 'Solicitar Orçamento Gratuito',
        description: 'Preencha o formulário e receba um orçamento personalizado sem qualquer compromisso. Responderemos em até 24 horas.',
        name: 'Nome Completo',
        phone: 'Telefone',
        email: 'Email',
        service: 'Tipo de Serviço',
        servicePlaceholder: 'Selecione um serviço',
        message: 'Descreva o que precisa',
        submit: 'Pedir Orçamento Gratuito',
        success: 'Orçamento solicitado com sucesso! Entraremos em contacto em breve.',
        error: 'Erro ao enviar pedido. Por favor, tente novamente.'
      },
      info: {
        title: 'Informações de Contacto',
        phone: 'Telefone',
        whatsapp: 'WhatsApp',
        email: 'Email',
        area: 'Área de Atendimento',
        areaValue: 'Toda região do Algarve-Faro'
      }
    },
    booking: {
      title: 'Agendar Serviço',
      subtitle: 'Já sabe o que precisa? Marque já a data e hora',
      description: 'Use este formulário quando já tiver decidido fazer o serviço e quiser marcar uma data específica. Para apenas pedir orçamento, use o formulário de contacto.',
      alert: '💡 Dica: Se ainda não tem certeza ou quer saber o preço primeiro, use "Pedir Orçamento" em vez de agendar.'
    },
    admin: {
      login: {
        title: 'Painel Administrativo',
        subtitle: 'Acesso restrito para administradores',
        email: 'Email',
        password: 'Senha',
        submit: 'Entrar',
        error: 'Email ou senha incorretos'
      },
      dashboard: {
        title: 'Painel de Controlo',
        subtitle: 'Gerir pedidos de orçamento',
        logout: 'Sair',
        totalRequests: 'Total de Pedidos',
        pending: 'Pendentes',
        inProgress: 'Em Andamento',
        completed: 'Concluídos',
        allRequests: 'Todos os Pedidos',
        filterAll: 'Todos',
        filterPending: 'Pendentes',
        filterInProgress: 'Em Andamento',
        filterCompleted: 'Concluídos',
        noRequests: 'Nenhum pedido encontrado',
        requestDetails: 'Detalhes do Pedido',
        updateStatus: 'Atualizar Status',
        statusUpdated: 'Status atualizado com sucesso',
        statusError: 'Erro ao atualizar status'
      },
      status: {
        pending: 'Pendente',
        in_progress: 'Em Andamento',
        completed: 'Concluído'
      }
    },
    footer: {
      company: 'Sancur Property Services',
      description: 'Serviços residenciais e comerciais de confiança no Algarve',
      rights: 'Todos os direitos reservados',
      quickLinks: 'Links Rápidos'
    },
    staff: {
      login: {
        title: 'Portal Staff',
        subtitle: 'Entre para ver a sua agenda',
        staffId: 'ID do Funcionário',
        staffIdPlaceholder: 'Introduza o seu ID',
        password: 'Palavra-passe',
        passwordPlaceholder: 'Introduza a sua palavra-passe',
        submit: 'Entrar',
        error: 'Falha no login. Tente novamente.'
      },
      dashboard: {
        title: 'Painel do Funcionário',
        welcome: 'Bem-vindo',
        todayJobs: 'Trabalhos Hoje',
        pending: 'Pendentes',
        completed: 'Concluídos',
        totalJobs: 'Total de Trabalhos',
        monthView: 'Vista Mensal',
        dayView: 'Vista Diária',
        noJobsToday: 'Sem trabalhos para hoje',
        noJobsSelected: 'Selecione um dia para ver os trabalhos',
        viewDetails: 'Ver Detalhes',
        new: 'NOVO',
        logout: 'Sair'
      },
      job: {
        details: 'Detalhes do Trabalho',
        client: 'Cliente',
        phone: 'Telefone',
        email: 'Email',
        address: 'Morada',
        eircode: 'Eircode',
        service: 'Serviço',
        date: 'Data',
        time: 'Hora',
        instructions: 'Instruções do Gestor',
        notes: 'Notas do Cliente',
        observations: 'Observações',
        addObservation: 'Adicionar observação...',
        saveNotes: 'Guardar Notas',
        openMaps: 'Abrir no Google Maps',
        timer: 'Cronómetro',
        start: 'Iniciar',
        pause: 'Pausar',
        finish: 'Terminar',
        completed: 'Concluído',
        inProgress: 'Em Progresso',
        pendingStatus: 'Pendente'
      },
      workHours: {
        title: 'Horas de Trabalho',
        totalHours: 'Total de Horas',
        jobsCompleted: 'Trabalhos Concluídos',
        avgPerJob: 'Média por Trabalho',
        period: 'Período',
        last7Days: 'Últimos 7 Dias',
        last30Days: 'Últimos 30 Dias',
        allTime: 'Todo o Tempo',
        exportPdf: 'Exportar PDF',
        noData: 'Sem dados para este período'
      },
      profile: {
        title: 'Perfil',
        personalInfo: 'Informações Pessoais',
        name: 'Nome',
        email: 'Email',
        phone: 'Telefone',
        staffId: 'ID do Funcionário',
        paymentInfo: 'Informações de Pagamento',
        iban: 'IBAN',
        security: 'Segurança',
        changePassword: 'Alterar Palavra-passe',
        currentPassword: 'Palavra-passe Atual',
        newPassword: 'Nova Palavra-passe',
        confirmPassword: 'Confirmar Palavra-passe',
        updatePassword: 'Atualizar Palavra-passe',
        passwordChanged: 'Palavra-passe alterada com sucesso',
        passwordError: 'Erro ao alterar palavra-passe'
      },
      nav: {
        dashboard: 'Painel',
        workHours: 'Horas',
        profile: 'Perfil'
      }
    },
    quote: {
      title: 'Orçamento Grátis',
      steps: {
        service: 'Serviço',
        property: 'Imóvel',
        photos: 'Fotos',
        date: 'Data',
        contact: 'Contacto',
        summary: 'Resumo'
      },
      step1: {
        title: 'Que tipo de limpeza?',
        subtitle: 'Escolha a opção que melhor se adequa.'
      },
      step2: {
        title: 'Detalhes do Imóvel',
        propertyType: 'Tipo de Imóvel',
        bedrooms: 'Quartos',
        bathrooms: 'Casas de Banho',
        extras: 'Serviços Extra',
        extrasSubtitle: 'Adicione serviços extra ao seu orçamento'
      },
      step3: {
        title: 'Fotos (Opcional)',
        subtitle: 'Ajude-nos a entender melhor as suas necessidades',
        upload: 'Carregar Fotos',
        maxPhotos: 'Máximo 5 fotos'
      },
      step4: {
        title: 'Escolha Data e Hora',
        subtitle: 'Selecione quando prefere que realizemos o serviço',
        selectDate: 'Selecione uma data',
        selectTime: 'Selecione uma hora',
        weekdaysNote: 'Dias de semana: a partir das 14:30',
        weekendsNote: 'Fins de semana: dia inteiro'
      },
      step5: {
        title: 'Informações de Contacto',
        firstName: 'Primeiro Nome',
        lastName: 'Apelido',
        phone: 'Telefone',
        email: 'Email',
        eircode: 'Eircode',
        address: 'Morada (Opcional)',
        message: 'Mensagem Adicional (Opcional)'
      },
      step6: {
        title: 'Resumo do Orçamento',
        service: 'Serviço',
        property: 'Imóvel',
        extras: 'Extras',
        date: 'Data',
        time: 'Hora',
        contact: 'Contacto',
        estimate: 'Estimativa',
        ourPrice: 'Nosso Preço',
        marketPrice: 'Média Dublin',
        savings: 'Poupa',
        submit: 'Enviar Pedido de Orçamento'
      },
      success: {
        title: 'Pedido de Orçamento Enviado!',
        message: 'Obrigado! Vamos analisar o seu pedido e entrar em contacto via WhatsApp ou telefone dentro de 2 horas.',
        steps: '3 PASSOS SIMPLES:',
        step1: 'Entraremos em contacto para confirmar detalhes',
        step2: 'Enviaremos o orçamento final',
        step3: 'Confirme e estaremos lá!'
      },
      buttons: {
        next: 'Seguinte',
        back: 'Voltar',
        submit: 'Enviar'
      },
      services: {
        regular: 'Limpeza Regular',
        regularDesc: 'Limpeza semanal ou quinzenal para manter sua casa fresca, organizada e em ordem.',
        deep: 'Limpeza Profunda',
        deepDesc: 'Uma limpeza completa e detalhada para casas que precisam de atenção extra em todos os cômodos.',
        office: 'Limpeza de Escritório',
        officeDesc: 'Limpeza profissional para escritórios e espaços comerciais.',
        endoftenancy: 'Limpeza Fim de Arrendamento',
        endoftenancyDesc: 'Ideal para o início ou fim de um contrato de arrendamento, quando a casa precisa estar impecável.',
        upholstery: 'Limpeza de Estofados',
        upholsteryDesc: 'Limpeza profunda para sofás, carpetes, colchões e móveis de tecido.',
        unsure: 'Não tenho certeza / Ajude-me a escolher',
        unsureDesc: 'Conte-nos sobre a sua casa e sugeriremos a melhor opção para você.'
      },
      popular: 'POPULAR'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      contact: 'Get Quote',
      booking: 'Book Now',
      gallery: 'Gallery'
    },
    hero: {
      title: 'Trusted Residential and Commercial Services',
      subtitle: 'Professional painting, repairs, cleaning, and maintenance in Algarve-Faro. Direct service, fair prices, and guaranteed quality.',
      cta: 'Request Quote'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Complete solutions for your home or business',
      painting: {
        title: 'Painting',
        description: 'Professional painting of rooms and small spaces'
      },
      repairs: {
        title: 'Small Repairs',
        description: 'Light bulb, socket, lock replacement and various adjustments'
      },
      cleaning: {
        title: 'Cleaning',
        description: 'Professional residential cleaning for your convenience'
      },
      maintenance: {
        title: 'Maintenance',
        description: 'Professional basic property maintenance'
      },
      furniture: {
        title: 'Furniture Assembly',
        description: 'Fast and safe assembly of various furniture'
      }
    },
    whyChoose: {
      title: 'Why Choose Sancur?',
      punctuality: {
        title: 'Punctuality',
        description: 'We respect your time and meet agreed deadlines'
      },
      professionalism: {
        title: 'Professionalism',
        description: 'Qualified team and excellent service'
      },
      fairPrice: {
        title: 'Fair Price',
        description: 'No middlemen, you pay less with guaranteed quality'
      },
      speed: {
        title: 'Speed',
        description: 'Quick services without compromising quality'
      }
    },
    howItWorks: {
      title: 'How It Works',
      step1: {
        title: 'Contact Us',
        description: 'Get in touch by phone, WhatsApp or form'
      },
      step2: {
        title: 'Quote',
        description: 'Receive a clear and transparent quote'
      },
      step3: {
        title: 'Service',
        description: 'We execute the work with quality and punctuality'
      }
    },
    testimonials: {
      title: 'What Our Clients Say',
      review1: {
        text: 'Excellent service! They painted my room in one day and the result was perfect. Very professional.',
        author: 'Maria Silva',
        location: 'Faro'
      },
      review2: {
        text: 'I needed several small repairs at home. They did everything quickly and at a great price.',
        author: 'João Santos',
        location: 'Albufeira'
      },
      review3: {
        text: 'They assembled my new furniture very efficiently. I highly recommend!',
        author: 'Ana Costa',
        location: 'Lagos'
      }
    },
    beforeAfter: {
      title: 'Before and After',
      subtitle: 'See the quality of our work'
    },
    guarantee: {
      title: 'Satisfaction Guarantee',
      description: 'We work until you are completely satisfied with the result'
    },
    about: {
      title: 'About Sancur Property Services',
      story: 'Founded in 2022 with the goal of bringing more comfort to people\'s homes, Sancur Property Services was born from a simple vision: to offer quality services without middlemen. We want you to pay less while receiving personalized and professional service.',
      mission: {
        title: 'Our Mission',
        description: 'To provide excellent residential and commercial services with direct service and fair prices, ensuring total customer satisfaction.'
      },
      values: {
        title: 'Our Values',
        list: [
          'Transparency in all quotes',
          'Commitment to quality and deadlines',
          'Personalized and human service',
          'Honesty and trust in every service'
        ]
      },
      commitment: {
        title: 'Our Commitment',
        description: 'At Sancur, you deal directly with those who perform the service. No middlemen, no surprises. Just work well done, with respect for your time and space.'
      }
    },
    servicesPage: {
      title: 'Our Services',
      subtitle: 'Complete solutions for your home and business in Algarve',
      cta: 'Request Quote'
    },
    contact: {
      title: 'Request a Quote',
      subtitle: 'Not sure yet? Get a free quote with no commitment',
      form: {
        title: 'Request Free Quote',
        description: 'Fill out the form and receive a personalized quote with no obligation. We will respond within 24 hours.',
        name: 'Full Name',
        phone: 'Phone',
        email: 'Email',
        service: 'Service Type',
        servicePlaceholder: 'Select a service',
        message: 'Describe what you need',
        submit: 'Request Free Quote',
        success: 'Quote requested successfully! We will contact you soon.',
        error: 'Error sending request. Please try again.'
      },
      info: {
        title: 'Contact Information',
        phone: 'Phone',
        whatsapp: 'WhatsApp',
        email: 'Email',
        area: 'Service Area',
        areaValue: 'All Algarve-Faro region'
      }
    },
    booking: {
      title: 'Book a Service',
      subtitle: 'Already know what you need? Schedule your date and time',
      description: 'Use this form when you have already decided to do the service and want to book a specific date. To just request a quote, use the contact form.',
      alert: '💡 Tip: If you are not sure yet or want to know the price first, use "Request Quote" instead of booking.'
    },
    admin: {
      login: {
        title: 'Admin Panel',
        subtitle: 'Restricted access for administrators',
        email: 'Email',
        password: 'Password',
        submit: 'Login',
        error: 'Incorrect email or password'
      },
      dashboard: {
        title: 'Control Panel',
        subtitle: 'Manage quote requests',
        logout: 'Logout',
        totalRequests: 'Total Requests',
        pending: 'Pending',
        inProgress: 'In Progress',
        completed: 'Completed',
        allRequests: 'All Requests',
        filterAll: 'All',
        filterPending: 'Pending',
        filterInProgress: 'In Progress',
        filterCompleted: 'Completed',
        noRequests: 'No requests found',
        requestDetails: 'Request Details',
        updateStatus: 'Update Status',
        statusUpdated: 'Status updated successfully',
        statusError: 'Error updating status'
      },
      status: {
        pending: 'Pending',
        in_progress: 'In Progress',
        completed: 'Completed'
      }
    },
    footer: {
      company: 'Sancur Property Services',
      description: 'Trusted residential and commercial services in Algarve',
      rights: 'All rights reserved',
      quickLinks: 'Quick Links'
    },
    staff: {
      login: {
        title: 'Staff Portal',
        subtitle: 'Sign in to view your schedule',
        staffId: 'Staff ID',
        staffIdPlaceholder: 'Enter your staff ID',
        password: 'Password',
        passwordPlaceholder: 'Enter your password',
        submit: 'Enter',
        error: 'Login failed. Please try again.'
      },
      dashboard: {
        title: 'Staff Dashboard',
        welcome: 'Welcome',
        todayJobs: "Today's Jobs",
        pending: 'Pending',
        completed: 'Completed',
        totalJobs: 'Total Jobs',
        monthView: 'Month View',
        dayView: 'Day View',
        noJobsToday: 'No jobs for today',
        noJobsSelected: 'Select a day to view jobs',
        viewDetails: 'View Details',
        new: 'NEW',
        logout: 'Logout'
      },
      job: {
        details: 'Job Details',
        client: 'Client',
        phone: 'Phone',
        email: 'Email',
        address: 'Address',
        eircode: 'Eircode',
        service: 'Service',
        date: 'Date',
        time: 'Time',
        instructions: 'Manager Instructions',
        notes: 'Client Notes',
        observations: 'Observations',
        addObservation: 'Add observation...',
        saveNotes: 'Save Notes',
        openMaps: 'Open in Google Maps',
        timer: 'Timer',
        start: 'Start',
        pause: 'Pause',
        finish: 'Finish',
        completed: 'Completed',
        inProgress: 'In Progress',
        pendingStatus: 'Pending'
      },
      workHours: {
        title: 'Work Hours',
        totalHours: 'Total Hours',
        jobsCompleted: 'Jobs Completed',
        avgPerJob: 'Avg per Job',
        period: 'Period',
        last7Days: 'Last 7 Days',
        last30Days: 'Last 30 Days',
        allTime: 'All Time',
        exportPdf: 'Export PDF',
        noData: 'No data for this period'
      },
      profile: {
        title: 'Profile',
        personalInfo: 'Personal Information',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        staffId: 'Staff ID',
        paymentInfo: 'Payment Information',
        iban: 'IBAN',
        security: 'Security',
        changePassword: 'Change Password',
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        confirmPassword: 'Confirm Password',
        updatePassword: 'Update Password',
        passwordChanged: 'Password changed successfully',
        passwordError: 'Error changing password'
      },
      nav: {
        dashboard: 'Dashboard',
        workHours: 'Hours',
        profile: 'Profile'
      }
    },
    quote: {
      title: 'Get Your Free Quote',
      steps: {
        service: 'Service',
        property: 'Property',
        photos: 'Photos',
        date: 'Date',
        contact: 'Contact',
        summary: 'Summary'
      },
      step1: {
        title: 'What type of cleaning?',
        subtitle: 'Choose the option that best suits your needs.'
      },
      step2: {
        title: 'Property Details',
        propertyType: 'Property Type',
        bedrooms: 'Bedrooms',
        bathrooms: 'Bathrooms',
        extras: 'Extra Services',
        extrasSubtitle: 'Add extra services to your quote'
      },
      step3: {
        title: 'Photos (Optional)',
        subtitle: 'Help us better understand your needs',
        upload: 'Upload Photos',
        maxPhotos: 'Maximum 5 photos'
      },
      step4: {
        title: 'Choose Date and Time',
        subtitle: 'Select when you prefer us to perform the service',
        selectDate: 'Select a date',
        selectTime: 'Select a time',
        weekdaysNote: 'Weekdays: from 14:30',
        weekendsNote: 'Weekends: all day'
      },
      step5: {
        title: 'Contact Information',
        firstName: 'First Name',
        lastName: 'Last Name',
        phone: 'Phone',
        email: 'Email',
        eircode: 'Eircode',
        address: 'Address (Optional)',
        message: 'Additional Message (Optional)'
      },
      step6: {
        title: 'Quote Summary',
        service: 'Service',
        property: 'Property',
        extras: 'Extras',
        date: 'Date',
        time: 'Time',
        contact: 'Contact',
        estimate: 'Estimate',
        ourPrice: 'Our Price',
        marketPrice: 'Dublin Average',
        savings: 'You Save',
        submit: 'Submit Quote Request'
      },
      success: {
        title: 'Quote Request Sent!',
        message: "Thank you! We'll review your request and contact you via WhatsApp or phone within 2 hours.",
        steps: '3 SIMPLE STEPS:',
        step1: "We'll contact you to confirm details",
        step2: "We'll send you the final quote",
        step3: 'Confirm and we\'ll be there!'
      },
      buttons: {
        next: 'Next',
        back: 'Back',
        submit: 'Submit'
      },
      services: {
        regular: 'Regular House Cleaning',
        regularDesc: 'Weekly or bi-weekly cleaning to keep your home fresh, organised and in order.',
        deep: 'Deep Cleaning',
        deepDesc: 'A complete and detailed clean for homes that need extra attention in every room.',
        office: 'Office Cleaning',
        officeDesc: 'Professional cleaning for offices and commercial spaces.',
        endoftenancy: 'End of Tenancy Cleaning',
        endoftenancyDesc: 'Ideal for the start or end of a rental contract, when the house needs to be spotless.',
        upholstery: 'Upholstery Cleaning',
        upholsteryDesc: 'Deep cleaning for sofas, carpets, mattresses and fabric furniture.',
        unsure: "I'm not sure / Help me choose",
        unsureDesc: "Tell us about your home and we'll suggest the best option for you."
      },
      popular: 'POPULAR'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      about: 'Nosotros',
      contact: 'Pedir Presupuesto',
      booking: 'Reservar',
      gallery: 'Galería'
    },
    hero: {
      title: 'Servicios Residenciales y Comerciales de Confianza',
      subtitle: 'Pintura, reparaciones, limpieza y mantenimiento profesional en Algarve-Faro. Servicio directo, precios justos y calidad garantizada.',
      cta: 'Pedir Presupuesto'
    },
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Soluciones completas para su hogar o negocio',
      painting: {
        title: 'Pintura',
        description: 'Pintura de habitaciones y pequeños espacios con acabado profesional'
      },
      repairs: {
        title: 'Pequeñas Reparaciones',
        description: 'Cambio de bombillas, enchufes, cerraduras y ajustes varios'
      },
      cleaning: {
        title: 'Limpieza',
        description: 'Limpieza profesional residencial para su comodidad'
      },
      maintenance: {
        title: 'Mantenimiento',
        description: 'Mantenimiento básico de inmuebles con profesionalismo'
      },
      furniture: {
        title: 'Montaje de Muebles',
        description: 'Montaje rápido y seguro de muebles diversos'
      }
    },
    whyChoose: {
      title: '¿Por Qué Elegir Sancur?',
      punctuality: {
        title: 'Puntualidad',
        description: 'Respetamos su tiempo y cumplimos plazos acordados'
      },
      professionalism: {
        title: 'Profesionalismo',
        description: 'Equipo cualificado y atención de excelencia'
      },
      fairPrice: {
        title: 'Precio Justo',
        description: 'Sin intermediarios, paga menos con calidad garantizada'
      },
      speed: {
        title: 'Rapidez',
        description: 'Servicios ágiles sin comprometer la calidad'
      }
    },
    howItWorks: {
      title: 'Cómo Funciona',
      step1: {
        title: 'Contáctenos',
        description: 'Póngase en contacto por teléfono, WhatsApp o formulario'
      },
      step2: {
        title: 'Presupuesto',
        description: 'Reciba un presupuesto claro y transparente'
      },
      step3: {
        title: 'Servicio',
        description: 'Ejecutamos el trabajo con calidad y puntualidad'
      }
    },
    testimonials: {
      title: 'Lo Que Dicen Nuestros Clientes',
      review1: {
        text: '¡Excelente servicio! Pintaron mi habitación en un día y el resultado quedó perfecto. Muy profesionales.',
        author: 'María Silva',
        location: 'Faro'
      },
      review2: {
        text: 'Necesitaba varias pequeñas reparaciones en casa. Lo hicieron todo rápidamente y a buen precio.',
        author: 'João Santos',
        location: 'Albufeira'
      },
      review3: {
        text: 'Montaron mis muebles nuevos con mucha eficiencia. ¡Lo recomiendo sin duda!',
        author: 'Ana Costa',
        location: 'Lagos'
      }
    },
    beforeAfter: {
      title: 'Antes y Después',
      subtitle: 'Vea la calidad de nuestro trabajo'
    },
    guarantee: {
      title: 'Garantía de Satisfacción',
      description: 'Trabajamos hasta que esté completamente satisfecho con el resultado'
    },
    about: {
      title: 'Sobre Sancur Property Services',
      story: 'Fundada en 2022 con el objetivo de brindar más comodidad a los hogares, Sancur Property Services nació de una visión simple: ofrecer servicios de calidad sin intermediarios. Queremos que pague menos mientras recibe un servicio personalizado y profesional.',
      mission: {
        title: 'Nuestra Misión',
        description: 'Proporcionar servicios residenciales y comerciales de excelencia, con atención directa y precios justos, garantizando la satisfacción total de nuestros clientes.'
      },
      values: {
        title: 'Nuestros Valores',
        list: [
          'Transparencia en todos los presupuestos',
          'Compromiso con calidad y plazos',
          'Atención personalizada y humana',
          'Honestidad y confianza en cada servicio'
        ]
      },
      commitment: {
        title: 'Nuestro Compromiso',
        description: 'En Sancur, usted trata directamente con quien ejecuta el servicio. Sin intermediarios, sin sorpresas. Solo trabajo bien hecho, con respeto por su tiempo y espacio.'
      }
    },
    servicesPage: {
      title: 'Nuestros Servicios',
      subtitle: 'Soluciones completas para su hogar y negocio en Algarve',
      cta: 'Solicitar Presupuesto'
    },
    contact: {
      title: 'Pedir Presupuesto',
      subtitle: '¿Aún no está seguro? Pida un presupuesto sin compromiso',
      form: {
        title: 'Solicitar Presupuesto Gratuito',
        description: 'Complete el formulario y reciba un presupuesto personalizado sin ningún compromiso. Responderemos en 24 horas.',
        name: 'Nombre Completo',
        phone: 'Teléfono',
        email: 'Email',
        service: 'Tipo de Servicio',
        servicePlaceholder: 'Seleccione un servicio',
        message: 'Describa lo que necesita',
        submit: 'Pedir Presupuesto Gratuito',
        success: '¡Presupuesto solicitado con éxito! Nos pondremos en contacto pronto.',
        error: 'Error al enviar solicitud. Por favor, inténtelo de nuevo.'
      },
      info: {
        title: 'Información de Contacto',
        phone: 'Teléfono',
        whatsapp: 'WhatsApp',
        email: 'Email',
        area: 'Área de Servicio',
        areaValue: 'Toda la región de Algarve-Faro'
      }
    },
    booking: {
      title: 'Agendar Servicio',
      subtitle: '¿Ya sabe lo que necesita? Reserve fecha y hora',
      description: 'Use este formulario cuando ya haya decidido hacer el servicio y quiera reservar una fecha específica. Para solo pedir presupuesto, use el formulario de contacto.',
      alert: '💡 Consejo: Si aún no está seguro o quiere saber el precio primero, use "Pedir Presupuesto" en vez de agendar.'
    },
    admin: {
      login: {
        title: 'Panel Administrativo',
        subtitle: 'Acceso restringido para administradores',
        email: 'Email',
        password: 'Contraseña',
        submit: 'Entrar',
        error: 'Email o contraseña incorrectos'
      },
      dashboard: {
        title: 'Panel de Control',
        subtitle: 'Gestionar solicitudes de presupuesto',
        logout: 'Salir',
        totalRequests: 'Total de Solicitudes',
        pending: 'Pendientes',
        inProgress: 'En Proceso',
        completed: 'Completados',
        allRequests: 'Todas las Solicitudes',
        filterAll: 'Todos',
        filterPending: 'Pendientes',
        filterInProgress: 'En Proceso',
        filterCompleted: 'Completados',
        noRequests: 'No se encontraron solicitudes',
        requestDetails: 'Detalles de la Solicitud',
        updateStatus: 'Actualizar Estado',
        statusUpdated: 'Estado actualizado con éxito',
        statusError: 'Error al actualizar estado'
      },
      status: {
        pending: 'Pendiente',
        in_progress: 'En Proceso',
        completed: 'Completado'
      }
    },
    footer: {
      company: 'Sancur Property Services',
      description: 'Servicios residenciales y comerciales de confianza en Algarve',
      rights: 'Todos los derechos reservados',
      quickLinks: 'Enlaces Rápidos'
    }
  }
};
